module.exports = __webpack_public_path__ + "static/media/Pathway Kids Page.993caea8.png";